import { CaretRightOutlined, RightOutlined } from "@ant-design/icons";
import {
    Collapse,
    Row,
    Col,
    Steps,
    Button,
    message,
    Form,
    Input,
    Image,
    Carousel,
    Card,
    Divider,
    Select,
    DatePicker,
    Radio,
    Checkbox,
    Space,
    Avatar,
    Spin,
    Tag
} from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import accountService from "../../../api/account.service";

import { ADD_MODE, DATE_FORMAT_DMY_SLASH, EDIT_MODE, SAVE_SUCCESS_MSG, SUCCESS_STATUS, UPDATE_SUCCESS_MSG } from "../../../utility/Constants";
import ModalWithMessageAndAction from "../../common/ModalWithMessageAndAction";

import moment from "moment";
import commonUtility from "../../../utility/Utils";
import AccountDrCrDetails from "../accountdetails/AccountDrCrDetails";
import { PRINT_BASE_URL } from "../../../utility/URL";

const { Option } = Select;
const { TextArea } = Input;

const defaultFormValues = {
    voucher_id: 0,
    voucher_no: "",
    voucher_date: "",
    mode: "ADD",
    cheque_number: "",
    cheque_date: "",
    narration:"",
    total_dr_amount:0,
    total_cr_amount:0,
    voucher_details:[]
};




const JournalVoucherEntryView = () => {

    const [accountList, setAccountList] = useState([]);


    const [form] = Form.useForm();
    const [openModal, setOpenModal] = useState(false);
    const [responseModalTitle, setResponseModalTitle] = useState("");
    const [responseModalMessage, setResponseModalMessage] = useState("");
    const [formErrorMessage, setFormErrorMessage] = useState("");
    const [isSaveLoaderEnable, setSaveLoaderEnable] = useState(false);

    const [totalDebitAmount, setTotalDebitAmount] = useState(0);
    const [totalCreditAmount, setTotalCreditAmount] = useState(0);

    const [responseModal, setResponseModal] = useState({
        responseModalTitle: '',
        isOpenModal: false,
        listLink: '',
        addmoreLink: '',
        responseModalMessage: '',
        printReuired: false,
        printUrl:""
    });
    

    const params = useParams();

    const onJournalVoucherSave = async (values) => {

        const dr_amount = values.total_dr_amount;
        const cr_amount = values.total_cr_amount;

        if(dr_amount > 0 && cr_amount > 0) {
            if(validateAmount()) {
                setSaveLoaderEnable(true)

                setResponseModal({
                    responseModalTitle: '',
                    isOpenModal: false,
                    listLink: '',
                    addmoreLink: '',
                    responseModalMessage: '',
                    printReuired: false,
                    printUrl:""
                });

                const data = { formdata: values };
                const response = accountService.journalVoucherSave(data).then((resdata) => {
    
    
                    if (resdata.response_data.mode == ADD_MODE) {
           
                        // setOpenModal(true)
                        // setResponseModalTitle("Success")
                        // setResponseModalMessage(`${SAVE_SUCCESS_MSG} with voucher no ${resdata.response_data.voucher_no}`)
                        const print_url = `${PRINT_BASE_URL}voucher/printpdf/${resdata.response_data.voucher_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`;

                        setResponseModal({
                            responseModalTitle: 'Success',
                            isOpenModal: true,
                            listLink: '/journalvoucher/list',
                            addmoreLink: '/journalvoucher/entry',
                            responseModalMessage: `${SAVE_SUCCESS_MSG} with voucher no ${resdata.response_data.voucher_no}`,
                            printReuired: true,
                            printUrl:print_url
                        });
                
                
                      }
                      else if(resdata.response_data.mode == EDIT_MODE) {
                        // setOpenModal(true)
                        // setResponseModalTitle("Success")
                        // setResponseModalMessage(`${UPDATE_SUCCESS_MSG}`)

                        const print_url = `${PRINT_BASE_URL}voucher/printpdf/${resdata.response_data.voucher_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`;

                        setResponseModal({
                            responseModalTitle: 'Success',
                            isOpenModal: true,
                            listLink: '/journalvoucher/list',
                            addmoreLink: '/journalvoucher/entry',
                            responseModalMessage: `${UPDATE_SUCCESS_MSG}`,
                            printReuired: true,
                            printUrl:print_url
                        });

                      }
    
                      setSaveLoaderEnable(false)
                
                });
            }
            else {
                setFormErrorMessage("Error : Total Debit and Total Credit amount must be equal")
            }
        }
        else{
            setFormErrorMessage("Error : Total Debit and Total Credit amount must be greater than 0")
        }
    };

    const handleCancel = () => {
        setOpenModal(false);
      };



    const validateAmount = () => {
        let dr_amount = form.getFieldValue("total_dr_amount");
        let cr_amount = form.getFieldValue("total_cr_amount");
        
        if(dr_amount != cr_amount) { return false;}
        return true;
    }




    const onVoucherDateChange = (date, dateString) => {
        form.setFieldsValue({
            voucher_date: dateString,
        });
    };
    
    
    const onChequeDateChange = (date, dateString) => {
        form.setFieldsValue({
            cheque_date: dateString,
        });
    };
    

    // useEffect(() => {
    //     accountService.accountListForJournal().then((res) => {
    //         if (res.data.response_status === SUCCESS_STATUS) {
    //             setAccountList(res.data.response_data);
    //         }

    //     });
    // }, []);


    /**
     * 
     */

    useEffect(()=>{
        //console.log("Voucher ID",params.voucher_id)

        if(params.voucher_id && params.voucher_id > 0) {

            const data = {
                formdata: {
                    voucher_master_id: params.voucher_id,
                },
              };
        
        
        
            accountService.multipleVoucherDataByID(data).then((res) => {
        
                if (res.response_status === SUCCESS_STATUS) {
                    setTotalDebitAmount(0)
                    setTotalCreditAmount(0)
                    const voucher_data = res.response_data[0];

                    console.log("voucher_dat",voucher_data)
                    form.setFieldsValue({
                        mode: "EDIT",
                        voucher_no:voucher_data.masterData.voucher_no,
                        voucher_id:voucher_data.masterData.id,
                        //voucher_date_picker,
                        voucher_date: commonUtility.dateFormatDDMMYYYY(new Date(voucher_data.masterData.voucher_date),"/") ,
                        voucher_date_picker: voucher_data.masterData.VoucherDate ? moment( voucher_data.masterData.VoucherDate, DATE_FORMAT_DMY_SLASH) : '',

                        cheque_date:voucher_data.masterData.chequeDate,
                        cheque_date_picker: voucher_data.masterData.chequeDate ? moment( voucher_data.masterData.chequeDate, DATE_FORMAT_DMY_SLASH) : '',

                        cheque_number:voucher_data.masterData.cheque_number,
                        narration:voucher_data.masterData.narration,

                        total_dr_amount:voucher_data.masterData.total_dr_amt,
                        total_cr_amount:voucher_data.masterData.total_cr_amt,
                    })

                    // Details
                    console.log("DetailData",voucher_data.detailsData)

                    let detailsDataList = voucher_data.detailsData

                    let obj = [];
                    detailsDataList.map((e) => {
                        const x = {
                            ac_tag: e.tran_tag,
                            account_id: e.account_master_id,
                            amount: e.amount,
                        };
                        obj.push(x);
                    });
  
                    form.setFieldsValue({ voucher_details: obj });


                    setTotalDebitAmount(voucher_data.masterData.total_dr_amt)
                    setTotalCreditAmount(voucher_data.masterData.total_cr_amt)
                }
            });

        }


    },[params.voucher_id]);


    const onDrCrCalculation = () => {
        setFormErrorMessage("")
        if(form.getFieldValue("voucher_details")) {
            let voucher_details = form.getFieldValue("voucher_details");

            let debit_amount = voucher_details.filter((obj) => obj?.ac_tag === 'Dr')
                                .reduce((sum, record) => parseFloat(sum) + parseFloat(isNaN(record?.amount) ? 0 : record?.amount),0)

            let credit_amount = voucher_details.filter((obj) => obj?.ac_tag === 'Cr')
                                .reduce((sum, record) => parseFloat(sum) +  parseFloat(isNaN(record?.amount) ? 0 : record?.amount),0)

            // console.log("debit_amount",debit_amount)
            // console.log("credit_amount",credit_amount)

            setTotalDebitAmount(commonUtility.sanitizeValue(debit_amount))
            setTotalCreditAmount(commonUtility.sanitizeValue(credit_amount))

            form.setFieldsValue({
                total_dr_amount : debit_amount,
                total_cr_amount : credit_amount,
            });
            

        }
       
        
    }

   

    const removeDetail = (index) => {
        const list = [...form.getFieldValue('voucher_details')];
        list.splice(index, 1);
        console.log("list",index)
        form.setFieldsValue({ voucher_details: list });
      }


    // const onDebitCreditChange = (index) => {
    //     console.log("index",index)
    // }


    const onDebitCreditChange = (e,v,index) => {
        
        const total_debit_amount = form.getFieldValue("total_dr_amount")
        const total_credit_amount = form.getFieldValue("total_cr_amount")

        if(v == "Dr") {
            
            const debit_amount_remaining = parseFloat(total_credit_amount)-parseFloat(total_debit_amount);
            if(debit_amount_remaining>0){
                form.setFields([
                    {
                      name: ["voucher_details", index, "amount"],
                      value: debit_amount_remaining,
                    }
                ]);
            }
            else{
                form.setFields([
                    {
                      name: ["voucher_details", index, "amount"],
                      value: 0,
                    }
                ]);
            }
        }
        else{

            const credit_amount_remaining = parseFloat(total_debit_amount)-parseFloat(total_credit_amount);
            if(credit_amount_remaining > 0) {
                form.setFields([
                    {
                      name: ["voucher_details", index, "amount"],
                      value: credit_amount_remaining,
                    }
                ]);
            }
            else{
                form.setFields([
                    {
                      name: ["voucher_details", index, "amount"],
                      value: 0,
                    }
                ]);
            }
        }
    }


    return (
        <div>
            <div className="form-input-style">
                <Row
                    className="login-first-step-row"
                    style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}
                >
                    <Col className="login-first-step-block-1" xs={24} xl={24}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onJournalVoucherSave}
                            autoComplete="off"
                            initialValues={defaultFormValues}
                            className="basicRegForm"
                            onFieldsChange={(event) => onDrCrCalculation()}
                            // onValuesChange={(event) => onFormCalculation()}
                            onKeyUp={onDrCrCalculation}
                            onBlur={onDrCrCalculation}
                            style={{ padding: "10px 20px" }}
                        >

                            <Row gutter={20}>
                                <Col className="gutter-row" xs={24} xl={7}>
                                    <Form.Item name="voucher_no" label="Voucher No">
                                        <Input placeholder="" readOnly={true} />
                                    </Form.Item>

                                    <Form.Item name="mode" label="mode" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="voucher_id" label="vid" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="total_dr_amount" label="tda " hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="total_cr_amount" label="tca " hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={7}>
                                    <Form.Item name="voucher_date_picker" label="Voucher Date" rules={[
                                        {
                                            required: true,
                                            message: 'Voucher Date is required',
                                        },
                                    ]}>
                                        <DatePicker
                                            format="DD/MM/YYYY"
                                            // onChange={onDateOfBirthChange}
                                            onChange={onVoucherDateChange}
                                            style={{ width: "100%" }}
                                            inputReadOnly={true}
                                        />
                                    </Form.Item>
                                    <Form.Item name="voucher_date" label="Voucher Dt" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={20}>

                                <Col xs={24} xl={7}>
                                    <Form.Item name="cheque_number" label="Cheque No">
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>



                                <Col xs={24} xl={7}>
                                    <Form.Item name="cheque_date_picker" label="Cheque Date" >
                                        <DatePicker
                                            format="DD/MM/YYYY"
                                            // onChange={onDateOfBirthChange}
                                            onChange={onChequeDateChange}
                                            style={{ width: "100%" }}
                                            inputReadOnly={true}
                                        />
                                    </Form.Item>
                                    <Form.Item name="cheque_date" label="Chq Dt" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={20}>
                                <Col xs={24} xl={14}>
                                    <Form.Item name="narration" label="Narration">
                                        <TextArea rows={1} placeholder="" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={20}>
                                <Col xs={24} xl={14}>
                                    <AccountDrCrDetails form={form} onDrCrCalculation={onDrCrCalculation} removeDetail={removeDetail} onDebitCreditChange={onDebitCreditChange} />
                                </Col>
                            </Row>

                            <Row gutter={20}>
                                <Col xs={24} xl={7}>
                                    <h3>Total Debit Amount : {totalDebitAmount}</h3> 
                                </Col>
                                <Col xs={24} xl={7} align="right">
                                    <h3>Total Credit Amount : {totalCreditAmount}</h3> 
                                </Col>
                            </Row>
                           
                          

                            <Row gutter={20}>
                                <Col xs={24} xl={12} >
                                    {
                                        formErrorMessage.length > 0 ? <><Tag color="error">{formErrorMessage}</Tag></> : ''
                                    }
                                    
                                </Col>
                                <Col xs={24} xl={2}>
                                    <Form.Item>
                                        {/* <Button htmlType="submit" className="custom-button-green" shape="round" style={{ margin: 8, border: 0 }}> Save <RightOutlined /></Button> */}





                                        {
                        isSaveLoaderEnable ? <Spin /> : <>
                           <Button htmlType="submit" className="custom-button-green" shape="round" style={{ margin: 8, border: 0 }}> Save <RightOutlined /></Button>
                        </>
                      }
                      {/* <Button htmlType="submit" className="custom-button-green" shape="round" style={{ margin: 8, border: 0 }}> Save <RightOutlined /></Button> */}

                                    </Form.Item>
                                </Col>
                            </Row>





                        </Form>
                    </Col>

                </Row>
            </div>


            {/* <ModalWithMessageAndAction key={commonUtility.randomID()} responseModalTitle={responseModalTitle} openModal={openModal} handleCancel={handleCancel} listLink={'/journalvoucher/list'} addmoreLink={'/journalvoucher/entry'} responseModalMessage={responseModalMessage} /> */}
            {
                responseModal.isOpenModal ? <>
                    <ModalWithMessageAndAction responseModal={responseModal} />
                </> : <></>
            }

        </div>
    )
}

export default JournalVoucherEntryView